import { useQuery } from '@tanstack/react-query'
import { commandFunctions } from '../../api/modules/commandApi'
import { CommandDescriptor } from '../../types/commandTypes'

const COMMANDS_QUERY_KEY = ['commands']

/**
 * Fetch the slash-command registry from `GET /api/commands`.
 *
 * Mirrors {@link useModels}: react-query with a generous `staleTime` so the
 * popup can open instantly after the first fetch. Pass `enabled: false` to defer
 * the request until the popup is first opened.
 */
export function useCommands(enabled = true) {
  const { data: commands = [], isLoading } = useQuery<CommandDescriptor[]>({
    queryKey: COMMANDS_QUERY_KEY,
    queryFn: () => commandFunctions.fetchCommands(),
    staleTime: 5 * 60 * 1000,
    retry: 2,
    enabled,
  })

  return { commands, isLoading }
}
